import uuid4 from 'uuid4';

export const getUid = () => uuid4();
export const isValidUid = (id) => uuid4.valid(id);
